<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 sm12 md10>
        <v-toolbar class="elevation-2">
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <SelectedDinamicField :itemAction="selectedPeriodos" :on-success="actionFieldData" />
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-toolbar>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="object" :urls="url" :message="message" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import SelectedDinamicField from '@/components/fields/SelectedDinamicField'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'ID', value: 'id', class: 'black--text' },
          { text: 'Nivel', value: 'nivel', class: 'black--text' },
          { text: 'Minimo', value: 'minimo', class: 'black--text' },
          { text: 'Maximo', value: 'maximo', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    selectedPeriodos: {
      field: 'selectDataServer',
      name: 'Ejercicio',
      nameid: 'ejercicio_id',
      url: '/nomina/config/ejercicio/show',
      rules: true,
      default: true,
      cols: 12
    },
    params: {},
    form: [],
    object: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog,
    SelectedDinamicField
  },
  mounted () {
    // this.getUrl('POST/nomina/config/niveles/show')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/nomina/config/niveles/show')
    },
    newData (item) {
      this.form = this.get_nivel_form
      this.object = {
        ejercicio_id: this.params.ejercicio_id
      }
      this.url = this.get_urls['POST/nomina/config/niveles/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Nivel' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    actionFieldData (obj) {
      this.table.header.loading = true
      this.params = {}
      if (obj.data) {
        this.params.ejercicio_id = obj.data
      }
      this.getUrl('POST/nomina/config/niveles/show')
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects', 'get_nivel_form'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/nomina/config/niveles/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
